<template>
  <div>
    <el-dialog
      v-if="visible"
      show-close
      :visible.sync="visible"
      width="480px"
      :title="$l('dialog_title_doc_enable') || '文档启用'"
      :close-on-click-modal="false"
      :before-close="() => $refs.main.cancel()"
      append-to-body
      v-el-dialog-drag
    >
      <Main
        ref="main"
        :custDocCode="custDocCode"
        @close="close"
        @reload="$emit('reload')"
      />
      <span slot="footer">
        <el-button size="small" @click="$refs.main.cancel()">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button type="primary" size="small" @click="$refs.main.confirm()">
          {{ $l('INDEX.btn_confirm') || '确认' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Main from './main.vue'
export default {
  components: { Main },
  props: {
    visible: { type: Boolean, default: false },
    custDocCode: { type: String, default: '' },
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
  },
}
</script>
